import { ReportChecklistData } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

interface Props {
  checklist: ReportChecklistData;
}

interface DataItem {
  id?: number;
  filePath?: string;
}

const ReportChecklistImages: React.FC<Props> = ({ checklist }) => {
  const columns = 5;

  let data = checklist.listChecklistImages?.reduce((acc, curr) => {
    const accIndex = acc.length ? acc.length - 1 : 0;

    if (acc[accIndex]?.length < columns) {
      return acc.map((a, i) => {
        if (i === accIndex) {
          return [...a, curr];
        }
        return a;
      });
    }

    return [...acc, [curr]];
  }, [] as DataItem[][]);

  data = data?.map((images) => {
    const imgLength = images.length;

    if (imgLength < columns) {
      return [
        ...images,
        ...Array.from({ length: columns - imgLength }).map((_, i) => ({
          id: i,
          filePath: undefined,
        })),
      ];
    }
    return images;
  });

  return (
    <table
      className={`reportChecklist-requestServices ${
        checklist.company?.bosch ? '-bosch' : ''
      }`}
    >
      <thead>
        <tr>
          <th colSpan={columns}>Imagens</th>
        </tr>
      </thead>

      <tbody>
        {!data?.length && (
          <tr>
            <td className="empty" colSpan={columns}>
              Não há imagens
            </td>
          </tr>
        )}

        {data?.map((images, index) => (
          <tr key={index}>
            {images.map((image, imageIndex) => (
              <td key={image.id}>
                {image.filePath && (
                  <img
                    src={image.filePath}
                    alt={`Imagem do veículo ${index + 1}.${imageIndex + 1}`}
                    style={{
                      width: '100%',
                      height: '8em',
                      objectFit: 'contain',
                      objectPosition: 'center',
                    }}
                  />
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ReportChecklistImages;
